'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorAlert = ErrorAlert;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

function getUserFriendlyErrorMessage(error, errorMessagesByStatusCode) {
  if (!errorMessagesByStatusCode[error.statusCode]) {
    return error.name + ': ' + error.message;
  }

  return errorMessagesByStatusCode[error.statusCode];
}

function renderClearButton(handleClear) {
  if (typeof handleClear !== 'function') {
    return null;
  }

  return _react2['default'].createElement('button', {
    className: 'btn btn-danger',
    onClick: function onClick() {
      handleClear();
    }
  }, 'Clear Errors');
}

function ErrorAlert(_ref) {
  var _ref$errors = _ref.errors,
      errors = _ref$errors === undefined ? [] : _ref$errors,
      _ref$errorMessagesByS = _ref.errorMessagesByStatusCode,
      errorMessagesByStatusCode = _ref$errorMessagesByS === undefined ? {} : _ref$errorMessagesByS,
      handleClear = _ref.handleClear;

  if (errors.length === 0) {
    return _react2['default'].createElement('span', null);
  }

  var recentErrors = (0, _lodash2['default'])(errors).uniqBy(function (error) {
    return error.statusCode;
  }).map(function (error, i) {
    return (// eslint-disable-next-line react/no-array-index-key
      _react2['default'].createElement('li', {
        key: i
      }, _react2['default'].createElement('span', null, getUserFriendlyErrorMessage(error, errorMessagesByStatusCode)))
    );
  }).value();
  return _react2['default'].createElement('div', {
    className: 'feed-back-container feed-back-container--error',
    role: 'alert'
  }, _react2['default'].createElement('div', {
    className: 'feed-back-container__error-message'
  }, _react2['default'].createElement('h4', {
    className: 'error-message__title'
  }, 'Error Encountered'), _react2['default'].createElement('ul', null, recentErrors)), renderClearButton(handleClear));
}

ErrorAlert.propTypes = {
  errors: _propTypes2['default'].arrayOf(_propTypes2['default'].object),
  errorMessagesByStatusCode: _propTypes2['default'].objectOf(_propTypes2['default'].string),
  handleClear: _propTypes2['default'].func
};
ErrorAlert.defaultProps = {
  errors: [],
  errorMessagesByStatusCode: {},
  handleClear: null
};